module.exports = __webpack_public_path__ + "static/media/gf.3186e80e.svg";